import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Slider from 'react-slick'

import { ImageItem } from '../../../entities/ImageItem'

import { GallerySlide } from './GallerySlide/GallerySlide'
import { GallerySliderArrow, RIGHT_ARROW } from './GallerySliderArrow/GallerySliderArrow'
import { Hide } from '../Hide'

import './GallerySlider.css'

class GallerySlider extends Component {
    next = () => {
        this.slider.slickNext()
    }
    previous = () => {
        this.slider.slickPrev()
    }

    render() {
        const { galleryItems } = this.props

        const settings = {
            infinite: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: galleryItems.length > 1 ? 1.05 : 1,
                        slidesToScroll: 1
                    }
                }
            ],
            appendDots: dots => (
                <div>
                    <ul> {dots} </ul>
                </div>
            ),
            customPaging: i => <div className="gallery-slider__dot" />,
            nextArrow: <GallerySliderArrow onClick={this.next} arrow={RIGHT_ARROW} />,
            prevArrow: <GallerySliderArrow onClick={this.previous} />
        }

        return (
            <Hide ifEmpty={galleryItems}>
                <div className="gallery-slider">
                    <Slider ref={c => (this.slider = c)} {...settings}>
                        {galleryItems.map((item, i) => {
                            return (
                                item && (
                                    <GallerySlide
                                        key={i}
                                        url={item.articleSliderImage}
                                        imageSource={item.source}
                                    />
                                )
                            )
                        })}
                    </Slider>
                </div>
            </Hide>
        )
    }
}

GallerySlider.propTypes = {
    galleryItems: PropTypes.arrayOf(PropTypes.instanceOf(ImageItem))
}

GallerySlider.defaultProps = {
    galleryItems: []
}

export { GallerySlider }
